import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import DowntiltDisplayContainer from './DowntiltDisplayContainer'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'

const mapStateToProps = ({ cameras }) => ({
  currentCamera: getCurrentCamera(cameras)
})

const BlindSpotPanelContainer = ({ classes, currentCamera: { horizontalAngleOfView } }) =>
  <div className={classes.container}>
    {
      horizontalAngleOfView >= 180 &&
      <div className={classes.cannotUse}>
        HAoV must be lower than 180 to enable blindspot preview
      </div>
    }
    <DowntiltDisplayContainer />
  </div>

export default connect(mapStateToProps)(injectSheet(style)(BlindSpotPanelContainer))



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/index.js